import { getOwnerId } from 'legacy/lut/selectors/app'
import {
  fetchCommitmentStatuses,
  IFetchAcknowledgementItems,
} from 'legacy/lut/services/partner360/commitment/fetchCommitmentStatuses'
import { IApiCommitmentStatus } from 'legacy/lut/services/partner360/commitment/models/apiCommitmentStatus'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { YEAR_WHEN_GP_APPEARS } from '../../../globalPartner/constants'
import { REQUEST_COMMITMENT_STATUSES } from '../constants'
import { selectCommitmentStatusesLoadingStatus } from '../selectors/selectCommitmentStatusesLoadingStatus'

export const requestCommitmentStatuses = createAsyncThunk<
  IApiCommitmentStatus[],
  Omit<IFetchAcknowledgementItems, 'ownerId'>
>(
  REQUEST_COMMITMENT_STATUSES,
  async ({ partnerId, fYear }, { getState }) => {
    const ownerId = compose(getOwnerId, getState)()

    return await fetchCommitmentStatuses({
      partnerId,
      fYear,
      ownerId,
    })
  },
  {
    condition: ({ partnerId, fYear }, { getState }) => {
      if (!partnerId || !fYear) {
        return false
      }

      if (partnerId.startsWith('GP') && fYear < YEAR_WHEN_GP_APPEARS) {
        return false
      }

      const status = compose(selectCommitmentStatusesLoadingStatus, getState)()
      if (status === RequestStatus.PENDING) {
        return false
      }

      return
    },
  }
)
